import React from 'react';
import { Box, Typography } from '@mui/material';

const TeamRequestsList = () => {
    return (
        <Box sx={{ p: 3, border: '1px dashed #ccc', borderRadius: '8px', textAlign: 'center' }}>
            <Typography variant="body1" sx={{ color: '#666' }}>
                No requests found. Requests will appear here when submitted.
            </Typography>
        </Box>
    );
};

export default TeamRequestsList;

